import * as React from 'react';
import { vividBlue } from '../abstracts/colours';

export interface GroupProps {
  fill?: string;
}

const Group: React.SFC<GroupProps> = ({ fill = vividBlue }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill={fill}
        d="M8 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C4.48 18.9 4 19.62 4 20.43V22h4.5v-1.61c0-.83.23-1.61.63-2.29zM24 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V22H28v-1.57zm-7.76-2.78c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9-1.08.48-1.76 1.56-1.76 2.74V22h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM12.07 20c.09-.23.13-.39.91-.69.97-.38 1.99-.56 3.02-.56s2.05.18 3.02.56c.77.3.81.46.91.69h-7.86zM16 12c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      />
    </svg>
  );
};

export default Group;
